"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopUpAnnouncement = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var _Modal = require("../Modal/Modal");
var _sanitizeHtmlOptions = _interopRequireDefault(require("../../constants/sanitizeHtmlOptions"));
var _types = require("../../types");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _RichText = require("../RichText");
var _tools = require("../../utils/tools");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var ButtonFunction;
(function (ButtonFunction) {
  ButtonFunction[ButtonFunction["ClosePopUp"] = 1] = "ClosePopUp";
  ButtonFunction[ButtonFunction["JumpUrl"] = 2] = "JumpUrl";
})(ButtonFunction || (ButtonFunction = {}));
var ButtonStyle;
(function (ButtonStyle) {
  ButtonStyle[ButtonStyle["PrimaryButton"] = 1] = "PrimaryButton";
  ButtonStyle[ButtonStyle["SecondaryButton"] = 2] = "SecondaryButton";
})(ButtonStyle || (ButtonStyle = {}));
var PopUpAnnouncement = function PopUpAnnouncement(props) {
  var _ref = props !== null && props !== void 0 ? props : {},
    popUpAnnouncement = _ref.popUpAnnouncement,
    onClose = _ref.onClose,
    visible = _ref.visible,
    trackingData = _ref.trackingData;
  var _ref2 = popUpAnnouncement !== null && popUpAnnouncement !== void 0 ? popUpAnnouncement : {},
    message = _ref2.message,
    title = _ref2.title,
    _ref2$button_setting = _ref2.button_setting,
    button_setting = _ref2$button_setting === void 0 ? [] : _ref2$button_setting;
  var buttons = (0, _react.useMemo)(function () {
    return button_setting === null || button_setting === void 0 ? void 0 : button_setting.map(function (v) {
      var _trackingData$trackin;
      var buttonTrackingData = _objectSpread(_objectSpread({}, trackingData), {}, {
        trackingdataBasic: _objectSpread({}, (_trackingData$trackin = trackingData === null || trackingData === void 0 ? void 0 : trackingData.trackingdataBasic) !== null && _trackingData$trackin !== void 0 ? _trackingData$trackin : {})
      });
      if (buttonTrackingData !== null && buttonTrackingData !== void 0 && buttonTrackingData.trackingdataBasic) {
        buttonTrackingData.trackingdataBasic.button_text = v.button_text;
      }
      var defaultObj = {
        text: v.button_text,
        style: {
          color: v.button_style === ButtonStyle.PrimaryButton ? '#EE4D2D' : 'rgba(0, 0, 0, 0.87)'
        },
        onClick: function onClick() {
          onClose();
        },
        trackingData: buttonTrackingData
      };
      if ((v === null || v === void 0 ? void 0 : v.button_function) === ButtonFunction.JumpUrl) {
        return _objectSpread(_objectSpread({}, defaultObj), {}, {
          action: {
            func: _types.ButtonEvents.Redirection,
            url_info: {
              url: v.url
            },
            showUserMessage: false
          }
        });
      }
      return defaultObj;
    });
  }, [button_setting]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    active: visible,
    onClose: onClose,
    title: title,
    className: (0, _getPrefixCls.getPrefixCls)('pop-up-announcement'),
    contentClassName: (0, _getPrefixCls.getPrefixCls)('pop-up-announcement-modal-content'),
    haveContentScrollbar: true,
    footer: {
      buttons: buttons
    }
  }, /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    className: (0, _getPrefixCls.getPrefixCls)('pop-up-announcement-content'),
    content: (0, _tools.formatHtml)((0, _sanitizeHtml.default)(message !== null && message !== void 0 ? message : '', _sanitizeHtmlOptions.default))
  })));
};
exports.PopUpAnnouncement = PopUpAnnouncement;